
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18117.6 -3281.6 18.699 16.2"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_6889","data-name":"Group 6889","transform":"translate(-19209 -3474)","opacity":".64"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1728","d":"M0 0h11.1","data-name":"Line 1728","transform":"translate(1092 200.5)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3550","d":"M9 12l3.8-3.9L9 4.2","data-name":"Path 3550","transform":"translate(1091.4 192.4)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3551","d":"M4.7 11.3v4.3h13.4V.6H4.7v4.3","data-name":"Path 3551","transform":"translate(1091.4 192.4)"}})])])
          )
        }
      }
    